// Per-conversation data-capture trace. Metadata only: counts and flags, never
// content and never employee identity. Used to spot capture failures (turns
// saved but no summary, scores missing, no themes) immediately.
import { supabase } from '@/lib/supabase';

export type CaptureTraceRow = {
  conversation_id: string;
  started_at: string;
  ended_at: string | null;
  channel: string;
  el_linked: boolean;
  turn_count: number;
  employee_turn_count: number;
  anchor_score_count: number;
  pulse_count: number;
  has_summary: boolean;
  insight_unit_count: number;
  action_item_count: number;
};

export async function fetchCaptureTrace(orgId: string, limit = 50) {
  const { data, error } = await supabase.rpc('admin_conversation_capture_trace', {
    _org_id: orgId,
    _limit: limit,
  });
  return { data: (data ?? []) as CaptureTraceRow[], error };
}

/** A conversation with a real transcript but no summary or no themes is a gap. */
export function captureGap(r: CaptureTraceRow): string | null {
  if (r.employee_turn_count === 0) return null;
  if (!r.has_summary) return 'No summary';
  if (r.insight_unit_count === 0) return 'No themes';
  return null;
}
